import { render, staticRenderFns } from "./appointForm.vue?vue&type=template&id=4f1f5d9e&scoped=true&"
import script from "./appointForm.vue?vue&type=script&lang=js&"
export * from "./appointForm.vue?vue&type=script&lang=js&"
import style0 from "./appointForm.vue?vue&type=style&index=0&id=4f1f5d9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1f5d9e",
  null
  
)

export default component.exports